import { createFileRoute } from "@tanstack/react-router";
import Settings from "@/features-root-user/settings";

export const Route = createFileRoute("/_root/root-user/settings")({
  component: Settings,
});
